import React from 'react';
import AboutSection from '../components/AboutSection';
import SEOHead from '../components/SEOHead';

const AboutPage = () => {
  return (
    <div className="pt-20">
      <SEOHead 
        title="About Gegadyne Energy | Battery Manufacturer Mumbai India"
        description="Gegadyne Energy - India's leading industrial battery manufacturer. Founded in 2015, we develop Multi-Ion technology for traction batteries, energy storage, and ground power. Headquartered in Mumbai."
        keywords="Gegadyne Energy, battery manufacturer India, industrial battery company Mumbai, Multi-Ion technology, Indian battery startup, energy storage company India"
        canonicalPath="/about"
      />
      <section className="py-12 sm:py-16 bg-gradient-to-b from-gray-900 to-gray-950">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-3xl sm:text-4xl lg:text-5xl xl:text-6xl font-bold text-white mb-4 sm:mb-6">
            About <span className="text-emerald-400">Gegadyne Energy</span>
          </h1>
          <p className="text-base sm:text-lg lg:text-xl text-gray-400 max-w-3xl mx-auto">
            Pioneering the future of industrial energy storage from India. Multi-Ion battery manufacturer since 2015.
          </p>
        </div>
      </section>
      <AboutSection />
    </div>
  );
};

export default AboutPage;
